
define(
    'jsx!components/modal/login',[
        "jquery",
        "underscore",
        "backbone",
        "react",
        "actions/viewbuncee",
        "jsx!components/login-public-tenant"
    ],
    function($,_,Backbone,React,ViewBunceeActions,Login){
        return React.createClass({
            displayName: "LoginModal",
            onLogin: function() {
                var parent = document.getElementById('buncee-modal');
                React.unmountComponentAtNode(parent);
            },
            hide: function (e) {
                e.preventDefault();
                e.stopPropagation();
                var parent = document.getElementById('buncee-modal');
                React.unmountComponentAtNode(parent);
            },
            render: function()
            {
                return (
                    React.createElement("div", {className: "login-container"}, 
                        React.createElement(Login, {close: this.hide})
                    )
                )
            }
        });
    }
);
